const app = require('app'),
    getCookie = require('./getCookie');

module.exports = function () {
    return getCookie('language');
};
